import React from 'react';
import { useNavigate } from 'react-router-dom';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';

const CreateVentasServiceOrder = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva orden de servicio (venta)</h1>
          <p className="text-gray-600 mt-1">
            Puede referenciar una cotización. Al emitirla, el servicio se registra en Resultados.
          </p>
        </div>
        <VentasCommercialForm
          mode="service_order"
          isPageMode
          onClose={() => navigate('/ventas/service-orders', { state: { posConfirmed: true } })}
          onSuccess={() => navigate('/ventas/service-orders', { state: { posConfirmed: true } })}
        />
      </div>
    </div>
  );
};

export default CreateVentasServiceOrder;
